import { ApiResponse } from 'app/types-shared';
import { RemoteData } from 'app/infrastructure/remote-data/index';
import { endpoint } from 'app/area/case/endpoints';

export const api = {
  
  changeLog: async (caseId: number, caseLogNo: number): Promise<number> => {

    return (await new RemoteData(`${endpoint.case}/${caseId}/changes`)
      .resource<ApiResponse<number>>()
      .filter({ to: caseLogNo })
      .single() as any).data;
  }

};
